<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useI18n } from "vue-i18n";

definePage({
  meta: {
    title: "generic.messages.success.thankYou",
    requiresAuth: false,
    layout: "public",
  },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="tw:min-h-full tw:flex tw:flex-col tw:items-center tw:justify-center tw:text-center tw:px-4"
  >
    <v-icon
      icon="mdi-alert-circle"
      size="96"
      color="error"
      class="tw:mb-6"
    />
    <h1 class="tw:text-3xl tw:font-semibold tw:!mt-6">
      {{
        t("generic.messages.failure.invalidEntity", { entity: t("generic.entity.questionnaire") })
      }}
    </h1>
    <p class="tw:text-on-surface/60">
      {{ t("generic.errors.questionnaireInvalid") }}
    </p>
  </div>
</template>

<style scoped></style>
